import { render, staticRenderFns } from "./PhotoThumbnailCard.vue?vue&type=template&id=6b8d7ab4&"
import script from "./PhotoThumbnailCard.vue?vue&type=script&lang=js&"
export * from "./PhotoThumbnailCard.vue?vue&type=script&lang=js&"
import style0 from "./PhotoThumbnailCard.vue?vue&type=style&index=0&id=6b8d7ab4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports